/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "Please enter a preset name" |
*
* @param {Standards_Preset_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_name_required = /** @type {((inputs?: Standards_Preset_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "de") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "es") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Please enter a preset name")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Please enter a preset name")
	return /** @type {LocalizedString} */ ("Please enter a preset name")
});